<template>
    <div class="audition-table recent-record" v-loading="loading">
        <div class="head">
            <div class="tit">{{ userName ? userName + ' · ' : '' }}近期战绩</div>
            <div class="nav" v-if="canExpand">
                <span @click="expand">更多</span>
            </div>
        </div>
        <div v-if="!loading && !rows.length" class="audition-empty">暂无近期战绩</div>
        <table v-else-if="rows.length" class="record-table">
            <thead>
                <tr>
                    <th>序号</th>
                    <th>期号/开奖号</th>
                    <th v-for="column in columns" :key="column.preIndexType">{{ column.label }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, index) in rows" :key="row.issueNumber || index">
                    <td>{{ index + 1 }}</td>
                    <td>
                        <div>{{ row.issueNumber }}期</div>
                        <div v-if="balls(row.openNbr).length" class="balls">
                            <span
                                v-for="(ball, ballIndex) in balls(row.openNbr)"
                                :key="ballIndex"
                                :class="{ blue: ballIndex === balls(row.openNbr).length - 1 }">{{ ball }}</span>
                        </div>
                    </td>
                    <td v-for="cell in row.cells" :key="cell.preIndexType">
                        <el-tooltip :disabled="!tip(cell)" :content="tip(cell)" placement="top">
                            <span
                                class="mark"
                                :class="[cell.result, { link: !!cell.entryId }]"
                                @click="goDetail(cell)">{{ mark(cell) }}</span>
                        </el-tooltip>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { getRecentRecord } from '@/api/audition'

export default {
    name: 'RecentRecordGrid',
    props: {
        userId: { type: [Number, String], default: null },
        preType: { type: String, default: '' },
        userName: { type: String, default: '' }
    },
    data () {
        return {
            loading: false,
            limit: 7,
            columns: [],
            rows: []
        }
    },
    computed: {
        canExpand () {
            return this.limit < 20 && this.rows.length >= this.limit
        }
    },
    watch: {
        userId () {
            this.limit = 7
            this.load()
        },
        preType () {
            this.limit = 7
            this.load()
        }
    },
    mounted () {
        this.load()
    },
    methods: {
        load () {
            if (!this.userId || !this.preType) {
                this.columns = []
                this.rows = []
                return
            }
            this.loading = true
            getRecentRecord({
                userId: this.userId,
                preType: this.preType,
                limit: this.limit
            }).then(res => {
                if (res.code === 200 && res.data) {
                    this.columns = res.data.columns || []
                    this.rows = res.data.rows || []
                } else {
                    this.columns = []
                    this.rows = []
                }
            }).catch(() => {
                this.columns = []
                this.rows = []
            }).finally(() => {
                this.loading = false
            })
        },
        expand () {
            this.limit = 20
            this.load()
        },
        balls (openNbr) {
            if (!openNbr) return []
            return String(openNbr).trim().split(/\s+/).filter(Boolean)
        },
        mark (cell) {
            if (!cell) return '--'
            if (cell.result === 'win') return '√'
            if (cell.result === 'lose') return '×'
            return '--'
        },
        tip (cell) {
            if (!cell || cell.result === 'empty') return ''
            if (cell.result === 'pending') return '未开奖'
            const parts = []
            if (cell.result === 'win') parts.push('中奖')
            if (cell.result === 'lose') parts.push('未中')
            if (cell.redHitCount != null) parts.push('命中 ' + cell.redHitCount + ' 个')
            if (cell.periodScore != null && cell.periodScore !== '') {
                parts.push('积分 ' + Number(cell.periodScore).toLocaleString())
            }
            if (cell.actualPrizeAmount != null && cell.actualPrizeAmount !== '') {
                parts.push('实际奖金 ' + Number(cell.actualPrizeAmount).toLocaleString() + ' 元')
            }
            return parts.join('，')
        },
        goDetail (cell) {
            if (!cell || !cell.entryId) return
            if (String(cell.entryId) === String(this.$route.params.id)) return
            this.$router.push('/hxwysz/detail/' + cell.entryId)
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../audition.scss";

.recent-record {
    margin-top: 24px;
}

.record-table {
    width: 100%;
    border-collapse: collapse;
    background: #fff;

    th,
    td {
        border: 1px solid #e6e6e6;
        padding: 10px 8px;
        text-align: center;
        font-size: 14px;
    }

    th {
        background: #347caf;
        color: #fff;
        font-weight: 500;
    }
}

.balls {
    margin-top: 4px;

    span {
        margin: 0 2px;
        color: #e1251b;
    }

    .blue {
        color: #1d4ed8;
    }
}

.mark {
    display: inline-block;
    min-width: 24px;
    color: #000;

    &.win {
        color: #2899df;
        font-weight: 700;
    }

    &.lose {
        color: #f00;
        font-weight: 700;
    }

    &.link {
        cursor: pointer;
    }
}
</style>
